<div class="iris-menu">
  <div class="global-menu-container">
    <sk-button
      class="global-menu-toggler"
      [appearance]="'icon'"
      (click)="toggleSidenav()"
      id="showSystemMenu"
      data-test="header-dropdown-menu-show-system-menu-button">
      <div class="hamburger">
        <div class="hamburger-box">
          <div class="hamburger-inner"></div>
        </div>
      </div>
    </sk-button>
  </div>

  @if (defaultAppRoute()) {
    <a [routerLink]="defaultAppRoute()" [title]=" 'label.Homepage' | translate " class="navbar-brand" data-test="header-dropdown-menu-link">
      <ng-container [ngTemplateOutlet]="appLogo"></ng-container>
    </a>
  } @else {
    <sk-button
      [appearance]="'icon'"
      class="navbar-brand"
      data-test="application-menu-toggler"
      [title]="'label.Applications' | translate"
      (click)="toggleApplicationMenuList()"
      [matTooltip]="'label.Applications' | translate"
      cdkOverlayOrigin
      #applicationMenuTrigger="cdkOverlayOrigin">
      <ng-container [ngTemplateOutlet]="appLogo"></ng-container>
    </sk-button>

    <ng-template cdkConnectedOverlay
                 [cdkConnectedOverlayOrigin]="applicationMenuTrigger"
                 [cdkConnectedOverlayOpen]="isApplicationMenuListOpen()"
                 [cdkConnectedOverlayHasBackdrop]="true"
                 [cdkConnectedOverlayPanelClass]="'application-menu-list-box'"
                 [cdkConnectedOverlayBackdropClass]="'application-menu-list-backdrop'"
                 (backdropClick)="toggleApplicationMenuList()">
      <header-applications-menu></header-applications-menu>
    </ng-template>
  }
</div>

<ng-template #appLogo>
  <span class="app-logo">
    @if (defaultAppHasImage()) {
      <img
        [src]="('data:image/png;base64,' + brand().data) | safeUrl"
        [alt]="brand().brand + ' logo'">
    } @else {
      @if (applicationIcon()) {
        <i class="app-icon" [ngClass]="applicationIcon()"></i>
      } @else if (applicationImage()) {
        <img [src]="(applicationImage()) | safeUrl" alt="Logo" class="app-logo-dots"/>
      }
    }
  </span>
</ng-template>
